import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.p-datepicker-buttonbar p-button button {
	color: ${dt('primary.700')} !important;
}

`;
